export enum sizeOptions {
  xs = "xs",
  sm = "sm",
}

export enum variantOptions {
  primary = "primary",
  success = "success",
  warning = "warning",
  danger = "danger",
}
